module.exports = __webpack_public_path__ + "img/wifx-light-dark.ea021e49.svg";